import React, { useState } from 'react'

import { Checkbox, Input, useFilter } from '@rewardops/ui'

import { handleEnterKeyPress } from '~/utils/event-handler-utils'
import DynamicScrollArea from '~/components/dynamic-scroll-area'

interface Category {
  id: string
  name: string
  key: string
}

interface CategoriesListFilterProps {
  categories: Category[]
  searchEnabled?: boolean
}

export const CategoriesListFilter = ({
  categories,
  searchEnabled = true,
}: CategoriesListFilterProps) => {
  const [searchQuery, setSearchQuery] = useState('')
  const { selectedCategories, addToSelectedCategory } = useFilter()

  const filteredCategories = React.useMemo(() => {
    return categories?.filter((category) =>
      category?.name?.toLowerCase().includes(searchQuery.toLowerCase()),
    )
  }, [categories, searchQuery])

  return (
    <>
      {searchEnabled && (
        <Input
          key="input"
          type="text"
          className="mb-5"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      )}
      <DynamicScrollArea maxHeightClass="h-[25vh]" className="mb-5">
        <div className="flex flex-col gap-3">
          {filteredCategories?.map((category) => (
            <div
              id={`category-checkbox-${category.id}`}
              key={category.id}
              role="button"
              tabIndex={0}
              className="flex cursor-pointer items-center space-x-2 font-normal"
              onKeyDown={(e) =>
                handleEnterKeyPress(e, () => addToSelectedCategory(category))
              }
              onClick={(e) => {
                e.preventDefault()
                addToSelectedCategory(category)
              }}
            >
              <Checkbox checked={selectedCategories?.includes(category.key)} />
              <div className="cursor-pointer hover:text-tenant-primary-color">
                {category.name}
              </div>
            </div>
          ))}
        </div>
      </DynamicScrollArea>
    </>
  )
}

export default CategoriesListFilter
